<template>
  <div class="app-container" style="padding: 40px; text-align: center;">
    <p>「车场车辆」已迁移至「捷卫士车辆管理」，正在跳转…</p>
  </div>
</template>

<script>
export default {
  name: 'JieweishiDeprecated',
  created() {
    this.$router.replace({ path: '/chechang-wuye/jwsVehicleManage', query: this.$route.query })
  },
}
</script>
